import { inject, Pipe, PipeTransform } from '@angular/core';

import { marker } from '@colsen1991/ngx-translate-extract-marker';
import { MINUTE_SECONDS, padStart } from '@senet-uiverse/common';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'hourDuration',
})
export class HourDurationPipe implements PipeTransform {
  private readonly translateService = inject(TranslateService);

  transform(minutes: number | null): string {
    if (!minutes) return '';

    const unit = this.translateService.instant(marker('common.duration-type.hour'), { type: 'short' });
    const hours = Math.floor(minutes / MINUTE_SECONDS); // Get the whole number of hours
    const minutesLeft = minutes % MINUTE_SECONDS; // Get the remaining minutes

    return minutesLeft > 0 ? `${hours}:${padStart(minutesLeft)}${unit}` : `${hours}${unit}`;
  }
}
